import { useRouteError } from 'react-router-dom'

import { ErrorState } from '@/components/feedback'

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message
  }
  return 'Something went wrong while rendering this page.'
}

export function RouteErrorPage() {
  const error = useRouteError()

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <ErrorState
        title="Unexpected error"
        description={getErrorMessage(error)}
        onRetry={() => window.location.reload()}
      />
    </div>
  )
}